import React from "react";
import { Author, QuoteLayout, Text } from "./styles.Quote";

interface Props {
  author?: string;
  position?: string;
}

export const Quote: React.FC<Props> = ({ author, position, children }) => {
  return (
    <QuoteLayout position={position}>
      <Text>{children}</Text>
      {author && <Author>{author}</Author>}
    </QuoteLayout>
  );
};
